<template>
  <div class="email-shot-configuration">
    <email-types-composer
      v-if="templateTab !== null"
      ref="emailTypesComposer"
      v-model="templateTab"
      :campaign="campaign.shotConfiguration.email"
      is-maria-campaign
      :is-maria-campaign-activated="isMariaCampaignActivated"
      :is-maria-campaign-finished="isMariaCampaignFinished"
      :disabled="disabled"
      :validations="emailPreviewValidation ? $v : validations"
      :tryingToSaveAsDraft="false"
      :goToLink="goToLink"
      :header-image-url="campaign.shotConfiguration.email.message.simple_email_configuration.header_image"
      :delete-header-image="deleteHeaderImage"
      :upload-header-image="modifyHeaderImg"
      :body-image-url="campaign.shotConfiguration.email.message.simple_email_configuration.image"
      :delete-body-image="deleteBodyImage"
      :upload-body-image="modifyBodyImg"
    />
    <div class="text-end px-6">
      <mf-button label="Enviar preview" data-cy="send-preview-modal-btnn" @click="openEmailPreview" />
      <send-email-preview-modal v-model="openDialog" :maria-campaign-variables="mariaCampaignVariables" :campaign="campaign.shotConfiguration.email" />
    </div>
    <clients-range-slider channel="email" :segments="campaign.segments" :version="campaign.version" />
    <credit-entry
      title="Quantidade de disparos e-mail disponíveis"
      :credits.sync="creditsValue"
      :disabled="disabled"
      :is-maria-campaign-activated="isMariaCampaignActivated"
      :is-maria-campaign-finished="isMariaCampaignFinished"
      channel-type="email"
      :validations="
        getSafe(() => validations.campaign.shotConfiguration.email.credits.$error) ? 'Defina a quantidade de créditos disponíveis nesta campanha.' : ''
      "
    />
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { notOnlySpace, isUrl } from '@/helpers/validators.js'
import { characterVariables } from '@/mixins/character-variables'
import ClientsRangeSlider from '@/modules/maria/campanha-da-maria/views/components/ClientsRangeSlider.vue'
import CreditEntry from '@/modules/maria/campanha-da-maria/views/components/CreditEntry.vue'
import SendEmailPreviewModal from '@/modules/campanhas/campanhas-email/views/components/SendEmailPreviewModal.vue'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'

export default {
  name: 'EmailChannel',
  components: {
    ClientsRangeSlider,
    CreditEntry,
    SendEmailPreviewModal,
    EmailTypesComposer: () => import('@/modules/campanhas/campanhas-email/views/components/EmailTypesComposer.vue'),
  },
  mixins: [characterVariables],
  props: {
    text: {
      type: String,
      default: '',
    },
    credits: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: Object,
      default: () => {},
    },
    validations: {
      type: Object,
      default: () => {},
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
    pricesValidation: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    templateTab: null,
    openDialog: false,
    emailPreviewValidation: false,
  }),
  computed: {
    campaignVersion() {
      return this.campaign.version === 2 || !this.campaign._id ? 'V2' : 'V1'
    },
    selectedEmailType() {
      return {
        0: 'SIMPLE',
        1: 'BUILDER',
        2: 'HTML',
      }[this.templateTab]
    },
    tabTypes() {
      return {
        SIMPLE: 0,
        BUILDER: 1,
        HTML: 2,
      }
    },
    textValue: {
      get() {
        return this.text
      },
      set(value) {
        this.$emit('update:text', value)
      },
    },
    creditsValue: {
      get() {
        return this.credits
      },
      set(value) {
        this.$emit('update:credits', value)
      },
    },
    formatedLink() {
      if (this.campaign.shotConfiguration.email.message.simple_email_configuration.click_to_call_button_link.includes('http')) {
        return this.campaign.shotConfiguration.email.message.simple_email_configuration.click_to_call_button_link
      }
      return `http://${this.campaign.shotConfiguration.email.message.simple_email_configuration.click_to_call_button_link}`
    },
    maxSubjectLength() {
      return this.lengthCounter(this.campaign.shotConfiguration.email.message.simple_email_configuration.subject, 50)
    },

    maxTextLength() {
      return this.lengthCounter(this.campaign.shotConfiguration.email.message.simple_email_configuration.text, 2000)
    },

    maxButtonTextLength() {
      return this.lengthCounter(this.campaign.shotConfiguration.email.message.simple_email_configuration.click_to_call_button_text, 20)
    },

    maxFooterLength() {
      return this.lengthCounter(this.campaign.shotConfiguration.email.message.simple_email_configuration.footer, 250)
    },

    firstOfferEachType() {
      const firstOfferEachType = {
        ...(this.campaign?.offer_sales?.length > 0
          ? {
              general: {
                name: this.campaign?.offer_sales[0]?.name,
                price_1: this.campaign?.offer_sales[0]?.price_1,
                price_2: this.campaign?.offer_sales[0]?.price_2,
                type: 'general',
              },
            }
          : {}),

        ...(this.campaign?.percentage_offer_sales?.length > 0
          ? {
              percentage: {
                name: this.campaign?.percentage_offer_sales[0]?.name,
                percentage_discount: this.campaign?.percentage_offer_sales[0]?.percentage_discount,
                type: 'percentage',
              },
            }
          : {}),

        ...(this.campaign?.takepay_offer_sales?.length > 0
          ? {
              takepay: {
                name: this.campaign?.takepay_offer_sales[0]?.name,
                take: this.campaign?.takepay_offer_sales[0]?.take,
                pay: this.campaign?.takepay_offer_sales[0]?.pay,
                type: 'takepay',
              },
            }
          : {}),

        ...(this.campaign?.combo_offer_sales?.length > 0
          ? {
              combo: {
                name: this.campaign?.combo_offer_sales[0]?.name,
                type: 'combo',
              },
            }
          : {}),
      }

      return firstOfferEachType[this.campaign.offerType]
    },
    mariaCampaignVariables() {
      return {
        products: {
          offer_sale: { ...this.firstOfferEachType },
        },
        campaign: {
          initial_date: this.campaign.initial_date,
          final_date: this.campaign.final_date,
        },
      }
    },
  },
  watch: {
    selectedEmailType() {
      this.$emit('selectEmailType', this.selectedEmailType)
      this.campaign.shotConfiguration.email.message.email_configuration_type = this.selectedEmailType
    },
    templateTab() {
      if (this.templateTab === 0) {
        this.campaign.shotConfiguration.email.message.html_email_configuration = {}
        this.campaign.shotConfiguration.email.message.builder_email_configuration = {}
      } else if (this.templateTab === 1) {
        this.campaign.shotConfiguration.email.message.simple_email_configuration = {}
        this.campaign.shotConfiguration.email.message.html_email_configuration = {}
      } else {
        this.campaign.shotConfiguration.email.message.simple_email_configuration = {}
        this.campaign.shotConfiguration.email.message.builder_email_configuration = {}
      }
    },
  },
  mounted() {
    const initEmailConfigurationType = this.campaign.shotConfiguration.email.message.email_configuration_type
    if (!initEmailConfigurationType) this.campaign.shotConfiguration.email.message.email_configuration_type = 'SIMPLE'
    this.templateTab = this.tabTypes[initEmailConfigurationType] || 0
  },
  methods: {
    goToLink() {
      window.open(this.formatedLink)
    },
    async modifyHeaderImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.campaign.shotConfiguration.email.message.simple_email_configuration.header_image = url
        })
    },
    async modifyBodyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.campaign.shotConfiguration.email.message.simple_email_configuration.image = url
        })
    },
    deleteHeaderImage() {
      this.campaign.shotConfiguration.email.message.simple_email_configuration.header_image = ''
    },
    deleteBodyImage() {
      this.campaign.shotConfiguration.email.message.simple_email_configuration.image = ''
    },
    openEmailPreview() {
      this.$emit('validEmailChannel')
      if (!this.pricesValidation) {
        this.emailPreviewValidation = true
        this.$v.$reset()
        this.$v.$touch()
        if (this.$v.$error) {
          this.$snackbar({
            message: 'Preencha todos os campos corretamente.',
            snackbarColor: 'error',
          })
          this.$nextTick(() => {
            this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
          })
          return
        }
        this.openDialog = true
        this.emailPreviewValidation = false
      }
    },
    async loadCampaignEmailConfiguration() {
      if (this.selectedEmailType !== 'BUILDER') return
      const messageConfiguration = await this.$refs.emailTypesComposer.getConfiguration()
      this.campaign.shotConfiguration.email.message = { ...this.campaign.shotConfiguration.email.message, ...messageConfiguration }
    },
  },
  validations() {
    return {
      campaign: {
        shotConfiguration: {
          email: {
            message: {
              subject: {
                required,
                notOnlySpace,
              },
              processed_html: {
                required,
                notOnlySpace,
              },
              ...(this.selectedEmailType === 'SIMPLE'
                ? {
                    simple_email_configuration: {
                      subject: {
                        required,
                        maxLength: maxLength(this.maxSubjectLength),
                        notOnlySpace,
                      },
                      text: {
                        required,
                        maxLength: maxLength(this.maxTextLength),
                        notOnlySpace,
                      },
                      click_to_call_button_text: {
                        required,
                        maxLength: maxLength(this.maxButtonTextLength),
                        notOnlySpace,
                      },
                      click_to_call_button_link: {
                        required,
                        notOnlySpace,
                        isUrl,
                      },
                      footer: {
                        required,
                        maxLength: maxLength(this.maxFooterLength),
                        notOnlySpace,
                      },
                      image: {
                        required,
                      },
                      header_image: {
                        required,
                      },
                    },
                  }
                : {}),
              ...(this.selectedEmailType === 'HTML'
                ? {
                    html_email_configuration: {
                      url: {
                        notOnlySpace,
                        isUrl,
                      },
                    },
                  }
                : {}),
            },
          },
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.email-shot-configuration {
  > .v-card {
    box-shadow: none;
  }

  & h3 {
    color: $cinza-d20;
    font-weight: 400;
  }
}
</style>
